import { connectStatusPage } from '../containers/status/connectStatusPage';
import StatusPage from '../containers/status/StatusPage';

export default connectStatusPage(StatusPage);
